import {
  Component,
  ViewEncapsulation,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  AfterViewInit,
  Injector,
} from "@angular/core";
import { delay, debounceTime, take } from "rxjs/operators";
import { Title, Meta } from "@angular/platform-browser";
import { CoreCOMService } from "./core/services/com.service";
import { Navigationtarget } from "./core/services/com/comEnvironmentEventsNavigationtarget";
import { CoreLogService } from "./core/services/log.service";
import { Router, RouterOutlet } from "@angular/router";

import { CircularInjectionHelper } from "./core/services/circularInjectionHelper";
import { customConfig } from "./custom/custom-config";
import { Subscription, Observable, fromEvent } from "rxjs";
import { ObjectObserverSyncHelper } from "./core/services/objectObserverSyncHelper";
import { env, environment } from "../environments/environment";
import { UserHelperService } from "./core/services/userHelper.service";
import { ScrollDispatcher } from "@angular/cdk/scrolling";
import { RouterHelperService } from "./core/services/routerHelper.service";
import { CoreUpdateService } from "./core/services/update.service";
import { StorageHive, LocalKeys } from "./core/services/valueStorage.service";
import Utils from "./core/shared/utils";
import { NavigationHelperService } from "./core/services/navigationHelper.service";
import { HomeReadyService } from "./core/services/homeReady.service";
import { OverlayContainer } from "@angular/cdk/overlay";
import { ScrollHelper } from "./core/shared/scrollHelper";
import { EMenuService } from "./core/services/emenu.service";

import { ObjectObserverFactory } from "./core/services/objectObserverFactory";
import {
  ContentType,
  YourAPPProductType,
  UserContentTypes,
} from "./core/shared/contentTypes";
import {
  MenuSettingsDataModel2,
  MenuSettingsDMKey,
  ProductDataModel4,
  WebshopSettingsDataModel2,
  WebshopSettingsDMKey,
} from "./core/shared/models";
import { CheckoutService } from "./core/services/checkout.service";
import { ProductObjectObserverData } from "./core/services/objectObserver.service";
import { WebShopService } from "./core/services/webShop.service";
import { BottomSheetHelperService } from "./core/services/bottomSheetHelper.service";
import { CoreLanguageService } from "./core/services/language.service";
import { ISOTService } from "./sot/services/ISOTService";
import { SOT_SERVICE_INJECTION_TOKEN } from "./sot/injectionToken";
import { CommunicationData } from "./core/services/communicationdata.service";
import { DataModel } from "./core/shared/models/syncModel";
import { InHouseOrderService } from "./core/services/inHouseOrder.service";
import { OverlaySpinnerService } from "./core/components/overlayspinner/overlaySpiner.service";
import { FirebaseMessaging, IFCMNotificationData } from "./core/services/com/comEnvironmentFirebaseCloudMessaging";
import { ReconnectDialogComponent } from "./core/modalDialogs";
import { MatBottomSheetRef } from "@angular/material";
import { WebShopMode } from "./core/services/IWebShopService";
import { PlatformDetector } from "./core/services/com/comEnvironmentPathConverter";
import { ClientType } from "./core/services/com/comEnvironmentClient";
import { BannerService } from "./core/directives/banner/banner.service";
import { RemoteGroupOrderService } from "./core/services/RemoteGroupOrder.service";
import { ViewportHelperService } from "./core/services/viewportHelper.service";
import { AccountPaymentService } from "./core/services/accountPayment.service";

declare var Adyen: any;

/** Ermöglicht es ein Custom Layout einzufügen */
export class CustomOverlayContainer extends OverlayContainer {
  constructor() {
    super(document);
  }

  public setContainer(container: HTMLElement) {
    this._containerElement = container;
  }
}

@Component({
  selector: "app",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  providers: [OverlaySpinnerService],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild("dialogContainer") dialogContainer: ElementRef;
  public isEMenu: boolean;
  // private lastOffset = 0;
  private lastOnline = true;
  public loading: boolean;
  private resizeTimeout: any;
  private pauseSupscription: Subscription;
  private resumeSupscription: Subscription;
  private onlineSupscription: Subscription;
  private offlineSupscription: Subscription;
  private clearDataSubscription: Subscription;
  private deviceReadySubscription: Subscription;
  private externIntentSupscription: Subscription;

  private _sotService: ISOTService; // for lazyloading
  private resizeObservable: Observable<Event>;
  private resizeSubscription: Subscription;
  // private likeSupscription: Subscription;
  // private scrollingSubscription: Subscription;
  // Scroll animation tracking: holds requestAnimationFrame ID to cancel in-flight scroll-to-top animations
  private scrollToTopAnimationFrameId: number | null = null;
  constructor(
    private _coreLogService: CoreLogService,
    private _coreLanguageService: CoreLanguageService,
    private title: Title,
    private meta: Meta,
    private _coreCOMService: CoreCOMService,
    private _router: Router,
    public scroll: ScrollDispatcher,
    private _routerHelperService: RouterHelperService,
    private _circularInjectionHelper: CircularInjectionHelper,
    private _userHelperService: UserHelperService,
    private _coreUpdateService: CoreUpdateService,
    private _navigationHelperService: NavigationHelperService,
    private _homeReadyService: HomeReadyService,
    private _overlayContainer: OverlayContainer,
    private _eMenuService: EMenuService,
    private _checkoutService: CheckoutService,
    private _webShopService: WebShopService,
    private _bottomSheetHelperService: BottomSheetHelperService,
    private _communicationData: CommunicationData,
    private _scrollHelper: ScrollHelper,
    private _injector: Injector,
    private _inHouseOrderService: InHouseOrderService,
    private _remoteGroupOrderService: RemoteGroupOrderService,
    private _overlaySpinnerService: OverlaySpinnerService,
    private _bannerService: BannerService,
    private _viewportHelperService: ViewportHelperService,
    private _objObsInjectHelper: CircularInjectionHelper,
    private _accountPaymentService: AccountPaymentService,
  ) {
    const me = this;
    /** set Application icons globally */

    me.loading = false;

    me.title.setTitle(customConfig.title);
    me.meta.addTag({
      name: "description",
      content: customConfig.meta_description,
    });

    me._watchLoader();
    me._watchNavigationEvent();

    me.deviceReadySubscription = me._coreCOMService.environment.events.deviceReady.subscribe(() => me.onDeviceReady());
    me.pauseSupscription = me._coreCOMService.environment.events.pause.subscribe(() => me.onPause());
    me.resumeSupscription = me._coreCOMService.environment.events.resume.subscribe(() => me.onResume());
    me.onlineSupscription = me._coreCOMService.environment.events.online.subscribe(() => me.onOnline());
    me.offlineSupscription = me._coreCOMService.environment.events.offline.subscribe(() => me.onOffline());

    me.clearDataSubscription =
      me._circularInjectionHelper.yourAppServer.Auth.ObserveClearUserData.subscribe(
        () => {
          me._userHelperService.clearHelperDataService();
          me._accountPaymentService.reset();
          // CleanUp all user content
          UserContentTypes.forEach((UserContentType) => {
            const userDataObsever =
              ObjectObserverFactory.GetObjectObserverByInjectionHelper<DataModel>(
                UserContentType,
                me._circularInjectionHelper
              );
            userDataObsever.DeleteLocalStoredData();
          });
        }
      );

    me._coreCOMService.environment.loader.removeTask("home_component");
    // Scroll to top on route navigation
    me._routerHelperService.LocationPopStateObserver.subscribe((popState) => {
      if (!popState) {
        // Cancel any pending scroll animation
        if (me.scrollToTopAnimationFrameId !== null) {
          cancelAnimationFrame(me.scrollToTopAnimationFrameId);
        }
        // Wait for two render frames to ensure layout is ready, then scroll to top
        me.scrollToTopAnimationFrameId = requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            (me._scrollHelper.getScrollElement() || window).scrollTo(0, 0);
            me.scrollToTopAnimationFrameId = null;
          });
        });
      } else {
        // TODO
        // keep the scroll position. because it is a navigateback.
      }
    });
    me.resizeObservable = fromEvent(window, "resize");
    me.resizeSubscription = me.resizeObservable
      .pipe(debounceTime(100))
      .subscribe((event) => {
        me._viewportHelperService.setViewHeight();
        me._viewportHelperService.scrollActiveElementIntoView();
      });

    // Handle keyboard open/close on mobile devices to adjust viewport height
    // iOS uses component-level setWebView() which calls IOSHelperService.setWebviewAfterBlur()
    me._viewportHelperService.registerKeyboardListeners();
  }

  ngOnDestroy(): void {
    const me = this;
    if (me.clearDataSubscription) {
      me.clearDataSubscription.unsubscribe();
    }
    if (me.offlineSupscription) {
      me.offlineSupscription.unsubscribe();
    }
    if (me.onlineSupscription) {
      me.onlineSupscription.unsubscribe();
    }
    if (me.resumeSupscription) {
      me.resumeSupscription.unsubscribe();
    }
    if (me.pauseSupscription) {
      me.pauseSupscription.unsubscribe();
    }
    if (me.deviceReadySubscription) {
      me.deviceReadySubscription.unsubscribe();
    }
    if (me.externIntentSupscription) {
      me.externIntentSupscription.unsubscribe();
    }
    if (me.resizeSubscription) {
      me.resizeSubscription.unsubscribe();
    }
    if (me.scrollToTopAnimationFrameId !== null) {
      cancelAnimationFrame(me.scrollToTopAnimationFrameId);
    }
    // Remove keyboard event listeners to prevent memory leaks
    me._viewportHelperService.unregisterKeyboardListeners();
  }

  async ngOnInit(): Promise<void> {
    const me = this;
    me.externIntentSupscription =
      me._coreCOMService.environment.events.externIntent.subscribe(
        async (url: string) => {
          let hasIntent = false;
          const urlParams = me.GetExternIntentUrlParams(url);
          const type = urlParams.get("type");
          if (
            //! type === "checkout" || checkout verarbeitet den intent momentan in der componente, das sollte korrigiert werden
            type === "checkout_ih" /* Payment over InHouse */
          ) {
            hasIntent = true;
            me.OnCheckoutIntent$(urlParams).then(/* keine aktion notwendig */);
          }
          else if (type === "signin") {
            hasIntent = true;
            await me.OnSigninIntent$(urlParams);
          }

          if (!hasIntent) {
            me._overlaySpinnerService.ShowLayoutSpinner();
            try {
              // schön wäre es, wenn die bindung in den InHouseOrderService verlegt werden könnte
              await me._inHouseOrderService.onExternIntent(url);
              me._overlaySpinnerService.HideLayoutSpinner();
            } catch (error) {
              me._overlaySpinnerService.HideLayoutSpinner();
              me._coreLogService.error("AppComponent.ngOnInit", "inHouseOrderService.onExternIntent(catch)", url, error);
            }
          } // else intent wurde bereits verarbeitet
        }
      );

    me.isEMenu = me._eMenuService.isActive;
    if (me.isEMenu) {
      document.documentElement.classList.add("emenu");
    }

    if (!me._coreCOMService.environment.client.isMobile) {
      document.documentElement.classList.add("browser");
    }

    // Cordova rueckt die WebView auf Android selbst um die Systemleisten ein.
    // Die Klasse setzt die safe-area-Insets im CSS auf 0, damit die App sie
    // nicht ein zweites Mal abzieht (siehe app.styles.scss).
    if (environment.producttype === YourAPPProductType.app_android) {
      document.documentElement.classList.add("cordova-inset-webview");
    }

    //Change http:// to https:// (if not in development)
    if (
      window.location.protocol === "http:" &&
      document.location.port !== "8000"
    ) {
      window.location.href = window.location.href.replace(
        "http://",
        "https://"
      );
    }

    // sync with server at start of the app
    if (
      me._circularInjectionHelper.coreCOMService.environment.client.isMobile
    ) {
      ObjectObserverSyncHelper.CompleteSynchronizeWithServer(me._circularInjectionHelper, false);
    } else {
      // Beim Browser werden die Daten bei bedarf heruntergeladen
      // todo: bei schnellem internet bzw. am desktop könnte man es herunterladen 
    }
    me._coreUpdateService.check(false);

    me.tryUpdatingDevice().catch((e) => {
      me._coreLogService.error("AppComponent.ngOnInit", "tryUpdatingDevice", e);
    });

    if (me._coreCOMService.environment.client.isMobile) {
      me._coreCOMService.environment.firebaseCloudMessaging
        .onTokenRefresh()
        .subscribe(() => {
          me.tryUpdatingDevice();
        });
    }

    // initialParams
    try {
      const urlParams = new URLSearchParams(window.location.search);

      // lng to set the initial language of the app
      if (urlParams.has("lng")) {
        const lng = urlParams.get("lng").toLowerCase();
        if (lng === "de" || lng === "en") {
          me._communicationData.setLanguageChoice(urlParams.get("lng"));
        }
      }

      if (env.producttype == YourAPPProductType.sot) {
        const locationParam = urlParams.has("loc") ? +urlParams.get("loc") : null;
        const portParam = urlParams.has("port") ? +urlParams.get("port") : null;
        const payPosParam = urlParams.has("pay_pos") ? +urlParams.get("pay_pos") : null;
        const payEcParam = urlParams.has("pay_ec") ? +urlParams.get("pay_ec") : null;
        const payCardParam = urlParams.has("pay_card") ? +urlParams.get("pay_card") : null;
        const payVoucherParam = urlParams.has("pay_voucher") ? +urlParams.get("pay_voucher") : null;
        const useBonussystemParam = urlParams.has("use_bonus") ? +urlParams.get("use_bonus") : null;
        const resetParam = urlParams.has("reset") ? +(urlParams.get("reset")) : 0;
        const menu_conceptParam = urlParams.has("menu_concept") ? +(urlParams.get("menu_concept")) : 0;
        const pager_lengthParam = urlParams.has("pager_length") ? +(urlParams.get("pager_length")) : 0;
        const in_house_sortimentParam = urlParams.has("in_house_sortiment") ? urlParams.get("in_house_sortiment").toUpperCase() : null;
        const pickup_sortimentParam = urlParams.has("pickup_sortiment") ? urlParams.get("pickup_sortiment").toUpperCase() : null;
        const in_house_peParam = urlParams.has("in_house_pe") ? +urlParams.get("in_house_pe") : null;
        const pickup_peParam = urlParams.has("pickup_pe") ? +urlParams.get("pickup_pe") : null;
        const location = locationParam >= 0 ? locationParam : null;
        const port = portParam > 0 ? portParam : null;
        const payPos = payPosParam == 1;
        const payEc = payEcParam == 1;
        const payCard = payCardParam == 1;
        const payVoucher = payVoucherParam == 1;
        const useBonussystem = useBonussystemParam == 1;
        // wenn reset gewünscht, wird der locale Speicher bereinigt
        const reset = resetParam == 1;
        // wenn menü konzept gewünscht, werden Abfrage Preise als Menü Preis dargestellt
        const menu_concept = menu_conceptParam == 1;
        // Pagernummer länge kann zwischen 2 und 4 geändert werden, standard ist 3 
        const pager_length = pager_lengthParam >= 2 && pager_lengthParam <= 4 ? pager_lengthParam : 3; // default 3, min 2, max 4
        // wenn in_house oder pickup sortiment übergeben wird, wird es statt der aus den einstellungen verwendet
        let in_house_sortiment = "";
        if (in_house_sortimentParam) {
          if (in_house_sortimentParam.length == 1 && in_house_sortimentParam.match(/[A-H]/)) {
            in_house_sortiment = in_house_sortimentParam;
          } else {
            me._coreLogService.error("APPComponent.ngOnInit", "in_house_sortiment: is not a sortiment", in_house_sortimentParam);
          }
        }
        let pickup_sortiment = "";
        if (pickup_sortimentParam) {
          if (pickup_sortimentParam.length == 1 && pickup_sortimentParam.match(/[A-H]/)) {
            pickup_sortiment = pickup_sortimentParam;
          } else {
            me._coreLogService.error("APPComponent.ngOnInit", "pickup_sortiment: is not a sortiment", pickup_sortimentParam);
          }
        }
        let in_house_pe = null;
        if (in_house_peParam) {
          if (in_house_peParam >= 0) {
            in_house_pe = in_house_peParam;
          } else {
            me._coreLogService.error("APPComponent.ngOnInit", "in_house_pe: unknown", pickup_peParam);
          }
        }
        let pickup_pe = null;
        if (pickup_peParam) {
          if (pickup_peParam >= 0) {
            pickup_pe = pickup_peParam;
          } else {
            me._coreLogService.error("APPComponent.ngOnInit", "pickup_pe: unknown", pickup_peParam);
          }
        }
        // lazyload SOTService
        me._sotService = me._injector.get(SOT_SERVICE_INJECTION_TOKEN);
        me._sotService.init(location, port, payEc, payPos, payCard, payVoucher, useBonussystem, reset, menu_concept, pager_length, in_house_sortiment, pickup_sortiment, in_house_pe, pickup_pe);
      } /** not sot */ else {
        let hasIntent = false;
        const type = urlParams.get("type");
        if (
          type === "checkout" ||
          type === "checkout_ih" /* Payment over InHouse */
        ) {
          hasIntent = true;
          me.OnCheckoutIntent$(urlParams).then(/* keine aktion notwendig */);
        } else if (type === "signin") {
          hasIntent = true;
          await me.OnSigninIntent$(urlParams);
        } else if (type === "groupcode" /* Gruppenbestellung Einladung */) {
          // Parameter etwa so ?type=groupcode&loc=40007&groupcode=4O7YWY3VOBEUXLKNEAY7P4WEIQ&groupname=HypGr&groupcreator=Nick
          hasIntent = true;
          let location: number = 0;
          let groupcode: string = null;
          let groupname: string = null;
          let groupcreator: string = null;
          try {
            location = +urlParams.get("loc");
            groupcode = urlParams.get("groupcode");
            groupname = urlParams.get("groupname");
            groupcreator = urlParams.get("groupcreator");
          } catch (e) {
            me._coreLogService.error(
              "APPComponent.ngOnInit",
              "groupcode: parse token from URLSearchParams (catch)",
              e
            );
          }

          me._routerHelperService.setRouteTargetDataByKey(
            "groupcode",
            groupcode
          );
          me._routerHelperService.setRouteTargetDataByKey("location", location);
          me._routerHelperService.setRouteTargetDataByKey(
            "groupname",
            groupname
          );
          me._routerHelperService.setRouteTargetDataByKey(
            "groupcreator",
            groupcreator
          );
          me._router.navigate(["/groupOrderInvite"]);
        } else if (type === "jump" /* RedirectToShop */) {
          hasIntent = true;
          const serviceParam = urlParams.has("ser") ? +urlParams.get("ser") : null;
          const locationidParam = urlParams.has("loc") ? +urlParams.get("loc") : null;
          const service = serviceParam !== null && serviceParam >= 0 ? serviceParam : null;
          const locationid = locationidParam !== null && locationidParam >= 0 ? locationidParam : null;
          if (me._coreCOMService.environment.client.isMobile && me._appExists) {
            me._handleAppNavigation(service, locationid)
          } else {
            // Redirect to webshop
            me._handleJumpLinkWebshopNavigation(service, locationid);
          }

        }
        // todo externer warenkorb hbenötigt eigene verarbeitung dan ist hasIntent nicht notwendig
        // externer warenkorb
        if (urlParams.has("token") && urlParams.has("hash")) {
          hasIntent = true;
          const unparsedUrlParams = {};
          for (const urlparam of location.search.substring(1).split("&")) {
            const keyValue = urlparam.split("=");
            unparsedUrlParams[keyValue[0]] = keyValue[1];
          }
          const token = unparsedUrlParams["token"];
          const hash = unparsedUrlParams["hash"];
          me._webShopService.UseFixedBasket(token, hash);
        }

        if (!hasIntent && !type) {
          // ohne intent und ohne type, bedeutet normaler start, dann kann versucht werden sich erneut am Tisch zu plazieren
          me.TryGetBackToStoredTableOrGroup().catch((error) => {
            me._coreLogService.error(
              "AppComponent.ngOnInit",
              "TryGetBackToStoredTableOrGroup catch",
              error
            );
          });
        }
      }
    } catch (e) {
      me._coreLogService.error(
        "AppComponent.ngOnInit",
        "parse URLSearchParams (catch)",
        e
      );
    }
  }

  /** Bereitet die URL-Parameter für externen Intent vor, wie in checkout.component */
  private GetExternIntentUrlParams(url: string): URLSearchParams {
    let params: string = "";

    url = decodeURIComponent(url || "");

    const queryIndex = url.indexOf("?");
    params = queryIndex >= 0 ? url.slice(queryIndex) : url;

    return new URLSearchParams(params);
  }

  /** Verarbeitet den Checkout Intent der durch das HypersoftPay ausgelöst wird */
  private async OnCheckoutIntent$(urlParams: URLSearchParams): Promise<void> {
    const me = this;
    const type = urlParams.get("type");
    if (
      type !== "checkout" &&
      type !== "checkout_ih" /* Payment over InHouse */
    ) {
      me._coreLogService.error("APPComponent.OnCheckoutIntent$", "wrong type", type, urlParams);
      return; // break
    }

    let token: string = null;
    try {
      token = urlParams.get("token");
    } catch (error) {
      me._coreLogService.error("APPComponent.OnCheckoutIntent$", "checkout/checkout_ih: parse token from URLSearchParams (catch)", error, urlParams);
      return; // break
    }

    try {
      const lastorderinfo = await me._checkoutService.getLastOrderInfo();
      if (lastorderinfo) {
        me._webShopService.toggleFixedMode(lastorderinfo.fixedBasket);
      }
      if (lastorderinfo && lastorderinfo.id != null) {
        try {
          const response = await me._checkoutService.GetStoredCheckoutPaymentModel(token, lastorderinfo.id);

          if (response.done === "DoAction") {
            me._coreLogService.error(
              "APPComponent.OnCheckoutIntent$",
              `checkout: _checkoutService.GetStoredCheckoutPaymentModel done='${response.action_json}'`,
              response
            );
          } else {
            me._checkoutService.ShowFinalResult(response);
            if (me._circularInjectionHelper.yourAppServer.coreCOMService.environment.client.type === ClientType.ios) {
              if (response.done === "Authorised") {
                Adyen.successDropIn(response.done);
              }
            }
          }
        } catch (error) {
          me._coreLogService.error(
            "APPComponent.OnCheckoutIntent$",
            "checkout: _checkoutService.GetStoredCheckoutPaymentModel",
            error
          );
        }
      } else {
        me._coreLogService.error(
          "APPComponent.OnCheckoutIntent$",
          "checkout: Redirected by Paypal but there is no last order"
        );
      }
    } catch (error) {
      me._coreLogService.error(
        "APPComponent.OnCheckoutIntent$",
        "checkout: _checkoutService.getLastOrderInfo",
        error
      );
    }
  }

  /**
   * handles signin redirect intent from OAuth flow.
   * reads token from url params, completes backend sign-in
   * and navigates user based on registration state.
   */
  private async OnSigninIntent$(urlParams: URLSearchParams): Promise<void> {
    const me = this;

    const type = urlParams.get("type");
    if (type !== "signin") {
      me._coreLogService.error("APPComponent.OnSigninIntent$", "wrong type", type, urlParams);
      return;
    }

    const done = urlParams.get("done");
    const token = urlParams.get("token");

    if (done !== "success" || !token) {
      me._coreLogService.error("APPComponent.OnSigninIntent$", "signin redirect invalid", { done, hasToken: !!token });
      return;
    }

    try {
      const response = await me._objObsInjectHelper.yourAppServer.Auth.GetThirdpartySigninResult(token);
      const ok = await me._objObsInjectHelper.yourAppServer.Auth.SignInWithStoredSigninResponse(response);

      if (!ok) {
        me._coreLogService.error("APPComponent.OnSigninIntent$", "SignInWithStoredSigninResponse returned false");
        return;
      }

      const confirmed = await me._userHelperService.IsRegistrationConfirmed(false, true);

      if (confirmed) {
        me._router.navigate(["/userprofile"]);
      } else {
        me._router.navigate(["/registrationdata"]);
      }
    } catch (error) {
      me._coreLogService.error("APPComponent.OnSigninIntent$", "signin", error);
    }
  }

  /** versuche erneut mit InHouse eine Verbindung wieder herzustellen */
  private async TryGetBackToStoredTableOrGroup(): Promise<boolean> {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    try {
      const response =
        await me._inHouseOrderService.TryGetBackToStoredTableOrGroup();
      me._overlaySpinnerService.HideLayoutSpinner();
      if (response && !response.success) {
        // bei not success wird der cache automatisch bereinigt
        me._coreLogService.info(
          "AppComponent.TryGetBackToStoredTableOrGroup",
          "inHouseOrderService.TryGetBackToStoredTableOrGroup not success"
        );
      } // else setzen nicht möglich oder home componente aktualisiert sich durch events
      return response && response.success;
    } catch (error) {
      me._overlaySpinnerService.HideLayoutSpinner();
      me._coreLogService.error(
        "AppComponent.TryGetBackToStoredTableOrGroup",
        "TryGetBackToStoredTableOrGroup catch",
        error
      );
      return Promise.reject();
    }
  }

  /** Updates DeviceInformation on Server, if either language or fcmToken differs from the last sent*/
  private async tryUpdatingDevice() {
    const me = this;

    if (me._circularInjectionHelper.yourAppServer.coreCOMService.environment.client.isMobile) {
      let needsToUpdateDevice = false;

      // Language
      try {
        const lastSendLanguage = await me._coreCOMService.environment.valueStorage.get(StorageHive.Local, LocalKeys.lastSendLanguage);
        const currentLanguage = await me._circularInjectionHelper.yourAppServer.Api.getLanguage();
        if (lastSendLanguage !== currentLanguage) {
          needsToUpdateDevice = true
        }
      } catch (error) {
        me._coreLogService.error("AppComponent.tryUpdatingDevice", "environment.valueStorage.get", error);
      }

      // FCM Token
      try {
        const hasPermission = await me._coreCOMService.environment.firebaseCloudMessaging.requestPermission();
        if (hasPermission) {
          const currentFCMToken = await me._coreCOMService.environment.firebaseCloudMessaging.getToken();
          const lastsendFCMToken = await me._coreCOMService.environment.valueStorage.get(StorageHive.Local, LocalKeys.yourAppDeviceFCMToken);
          if (lastsendFCMToken !== currentFCMToken && !Utils.IsNullOrEmpty(currentFCMToken)) {
            needsToUpdateDevice = true
          }
        } else {
          me._coreLogService.info("AppComponent.tryUpdatingDevice", "requestPermission", "Permission denied");
        }
      } catch (error) {
        me._coreLogService.error("AppComponent.tryUpdatingDevice", "compare FcmTokens", error);
      }

      // Update
      if (needsToUpdateDevice) {
        me._circularInjectionHelper.yourAppServer.Api.UpdateDevice().catch(
          (error) => {
            me._coreLogService.error("AppComponent.tryUpdatingDevice", "yourAppServer.Api.UpdateDevice", error);
          }
        );
      }
    }
  }

  // hält die pause des InHouseService zurück
  private onPauseDelay: NodeJS.Timer = null;
  /** Called, if the Device is suspend */
  private onPause(): void {
    const me = this;
    //! todo später fixen
    // try execute it later
    me.onPauseDelay = setTimeout(() => {
      me.onPauseDelay = null;
      me._inHouseOrderService.Pause();
    }, 1000 * 5);
  }

  /** Called, if the Device is resumed */
  private onResume(): void {
    const me = this;
    if (me._circularInjectionHelper.coreCOMService.environment.client.isMobile) {
      ObjectObserverSyncHelper.CompleteSynchronizeWithServer(
        me._circularInjectionHelper,
        false
      );
    } else {
      // Browser hat kein Storage daten wrden bei bedarf heruntergeladen
    }
    //! todo ist hier ein restoreFromValueStorage wirklich notwendig, weil es die initialisierung ändern
    me._webShopService.restoreFromValueStorage();
    //! todo später fixen
    // try stop before timeout reach
    if (me.onPauseDelay) {
      clearTimeout(me.onPauseDelay);
      me.onPauseDelay = null;
    }
    me._inHouseOrderService.Resume();
    me._handleRemoteGroupStateChange();
  }

  /** Called, if the Device comes online */
  private onOnline(): void {
    const me = this;
    me._circularInjectionHelper.yourAppServer.Auth.SignInAnonymousOrNobodyIfNeed();

    if (env.producttype != YourAPPProductType.sot) {
      me.closeReconnectDialog();
      me.TryGetBackToStoredTableOrGroup()
        .then((success) => {
          // Leite den Gast zurück an den Tisch
          if (success) {
            me._inHouseOrderService.openInHauseLandingPage();
          }
        })
        .catch((error) => {
          me._coreLogService.error(
            "AppComponent.onOnline",
            "TryGetBackToStoredTableOrGroup catch",
            error
          );
        });
    }

    if (!me.lastOnline && me._coreCOMService.environment.client.isMobile) {
      // if device startet offline and gose online, check the versione once
      if (!me._coreUpdateService.has_checked) {
        me._coreUpdateService.check(false);
      }
    } else {
      // Browser has no Version
    }

    me.lastOnline = true;
  }

  /** Called, if the Device go offline */
  private onOffline(): void {
    const me = this;
    me.lastOnline = false;
    if (env.producttype != YourAPPProductType.sot) {
      if (me._webShopService.getServiceMode() == WebShopMode.OrderToTable) {
        me.openReconnectDialog();
        me._inHouseOrderService.leaveTable(false);
        // setze den Servicemode zurück um im fall des Offline>Online>Offline weiter den ReconnectDialog anzuzeigen
        me._webShopService.setServiceMode(WebShopMode.OrderToTable);
      }
    }
  }

  public get isRemoteGroupOrder(): boolean {
    const me = this;
    const serviceID = me._webShopService.getServiceMode();
    const isRemoteOrder = serviceID === WebShopMode.DeliveryGroup || serviceID === WebShopMode.PickupGroup
    return isRemoteOrder;
  }

  private _handleRemoteGroupStateChange() {
    if (this.isRemoteGroupOrder) {
      if (!this._remoteGroupOrderService.userIsGroupCreator) {
        let notActive: boolean = false;
        let finished: boolean = false;
        this._remoteGroupOrderService.groupStatusFinished$.pipe(take(1)).subscribe(value => finished = value).unsubscribe();
        this._remoteGroupOrderService.groupNotActive$.pipe(take(1)).subscribe(value => notActive = value).unsubscribe();
        if (finished) {
          this._remoteGroupOrderService.handleGroupStateFinishedOnAppResume();
        } else if (notActive) {
          this._remoteGroupOrderService.handleGroupStateDeleteOnAppResume();
        }//else do nothing
      }

    }
  }

  /** Hält referenz auf ein geöffneten Reconnect Dialog */
  private _reconnectDialog: MatBottomSheetRef<ReconnectDialogComponent, any> =
    null;

  /** Öffnen eines Reconnect Dialogs (Achtung muss mit closeReconnectDialog geschloßen werden) */
  private openReconnectDialog() {
    const me = this;
    me.closeReconnectDialog();
    me._reconnectDialog = me._bottomSheetHelperService.open(
      ReconnectDialogComponent,
      {
        autoFocus: false,
        disableClose: true,
      }
    );
  }

  /** Schließt ein geöffneten Reconnect Dialogs */
  private closeReconnectDialog() {
    const me = this;
    if (me._reconnectDialog) {
      me._reconnectDialog.dismiss();
    }
  }

  /** Called, when the Device is ready */
  private onDeviceReady(): void {
    const me = this;

    me.useCordovasInAppBrowserAsOverload();

    // Wenn die Browserversion eMenu bereit ist, schnell die Produkte vorladen.
    if (me.isEMenu || environment.producttype === YourAPPProductType.webshop) {
      const _webshopSettingsObsServ =
        ObjectObserverFactory.GetObjectObserverByInjectionHelper<WebshopSettingsDataModel2>(
          ContentType.WebshopSettings,
          me._circularInjectionHelper
        );
      const _menuSettingsObsServ =
        ObjectObserverFactory.GetObjectObserverByInjectionHelper<MenuSettingsDataModel2>(
          ContentType.MenuSettings,
          me._circularInjectionHelper
        );
      Promise.all([
        _menuSettingsObsServ.GetObject(MenuSettingsDMKey),
        _webshopSettingsObsServ.GetObject(WebshopSettingsDMKey),
      ])
        .then(([menuSettings, webshopSettings]) => {
          const sortiments: string[] = []; // Create Map to avoid duplicates
          webshopSettings.ordertypes.forEach((s) => {
            if (!sortiments.includes(s.sortiment)) {
              sortiments.push(s.sortiment);
            }
          });
          // wenn die Anzahl der Standorte zu groß ist, müsste der Abgleich durch ein geziehlten Abruf später erfolgen
          if (menuSettings.locations.length < 10) {
            for (let index = 0; index < menuSettings.locations.length; ++index) {
              for (const sortiment of sortiments) {
                const data = new ProductObjectObserverData(
                  menuSettings.locations[index],
                  sortiment
                );
                // produkte seperat laden (um selbe bilder nicht doppelt und Producte ohne Bilder nicht zu laden)
                const _productObsServ =
                  ObjectObserverFactory.GetObjectObserverByInjectionHelper<ProductDataModel4>(
                    ContentType.sub_Product,
                    me._circularInjectionHelper,
                    data
                  );
                _productObsServ.GetObjectsByFilter((model) => false); // nur Synchronisation anstoßen und nichts zurückgeben

                if (environment.producttype === YourAPPProductType.app_android || environment.producttype === YourAPPProductType.app_ios) {
                  // wenn es eine App ist kann der Speicher sofort freigegeben werden, da es bei bedarf wieder geladen wird um ram zu entlasten
                  ObjectObserverFactory.ReleaseObjectObserver(ContentType.sub_Product, data);
                }
              }
            }
          } // else synchronisation erfolgt später bei anforderung
        })
        .catch((e) => {
          me._coreLogService.error(
            "AppComponent.onDeviceReady",
            "Promise.all",
            e
          );
        });
    }

    // Register to FirebaseCloudMessaging and local PushNotifications
    const homeReadySubscription = me._homeReadyService.homeready.subscribe(
      () => {
        homeReadySubscription.unsubscribe();


        if (me._coreCOMService.environment.client.isMobile) {
          me._coreCOMService.environment.firebaseCloudMessaging.requestPermission().then(
            permissionGranted => {
              console.log("Permissions for notifications:" + (permissionGranted ? "granted" : "denied"));
            }
          );

          me._coreCOMService.environment.firebaseCloudMessaging
            .onNotification()
            .subscribe(
              (data: IFCMNotificationData) => {
                if (data.notification !== undefined) {
                  // Foreground messages have notification information to be processed.
                  // Background messages have only data information for navigation, cause the notification was already created by the plugin.
                  me.createLocalNotification(data, data.eventInformation);
                }

                if (data.wasTapped && data.eventInformation !== undefined) {
                  me._navigationHelperService.tryNavigateToContent(+data.eventInformation.contentType, +data.eventInformation.contentID).catch((error) => {
                    me._coreLogService.error("AppComponent.onDeviceReady", "tryNavigateToContent", "Unable to navigate! Reason: " + error);
                  });
                }
              }
            );
        }

        me._coreCOMService.environment.notification
          .observeClick()
          .subscribe(
            (notification: {
              [x: string]: { [x: string]: string | number };
            }) => {
              me._navigationHelperService.tryNavigateToContent(
                +notification["data"]["contentType"],
                +notification["data"]["contentID"]
              );
            }
          );
      }
    );
  }

  private useCordovasInAppBrowserAsOverload() {
    if (PlatformDetector.isAndroid() || PlatformDetector.isIOS()) {
      window.open = cordova.InAppBrowser.open;
    }
  }

  private createLocalNotification(
    data: IFCMNotificationData,
    customData?: Object
  ) {
    const title = data.notification.title;
    let body = data.notification.body;

    if (!Utils.IsNull(title)) {
      body = Utils.IsNull(body) ? "" : body;
      this._coreCOMService.environment.notification.globalCustomData(title, body, customData, true);
    }
  }

  private _watchLoader() {
    this._coreCOMService.environment.loader.visible.pipe(delay(10)).subscribe(
      (visible) => {
        this.loading = visible;
      },
      (error) => {
        this._coreLogService.error(
          "App Component: Der Status des Loaders konnte nicht gelesen werden",
          error
        );
      }
    );
  }

  private _watchNavigationEvent() {
    const me = this;
    this._coreCOMService.environment.events.navigate.pipe(delay(10)).subscribe(
      (target: Navigationtarget) => {
        me._router.navigate(target.commands, target.extras);
      },
      (error) => {
        this._coreLogService.error(
          "App Component: Fehler bei einem Navigationevent des Wrappers",
          error
        );
      }
    );
  }

  public prepareRoute(outlet: RouterOutlet) {
    return (
      outlet &&
      outlet.activatedRouteData &&
      outlet.activatedRouteData["animation"]
    );
  }

  /** Sets the data and navigates to the webshop
   *  Showing a warning dialog if needed */
  private _handleJumpLinkWebshopNavigation(service: number | null, locationid: number | null): void {
    const me = this;
    me._webShopService.openWarningResetBasketDialogIfNeed(locationid, service, (agree) => {
      if (agree) {
        me._webShopService.navigateToWebshop(service, locationid);
      } /* else do nothing */
    }
    );
  }

  /** Checks if the app exists by checking the store URLs */
  private get _appExists(): boolean {
    const appExist = !Utils.IsNullOrEmpty(environment.storeURL.AppleStore) || !Utils.IsNullOrEmpty(environment.storeURL.GooglePlayStore)
    return appExist;
  }

  /** Checks if the current browser is Safari on iOS */
  private get _isSafariOnIOS() {
    const me = this;
    //!Mark On iPad "Request desktop website" is the default Safari setting
    const isSafariOnIOs = (me._coreCOMService.environment.client.isBrowserMobileSafari || me._coreCOMService.environment.client.isBrowserSafari);
    return isSafariOnIOs;
  }

  /** Handles the app navigation*/
  private _handleAppNavigation(service: number, locationid: number) {
    const me = this;
    try {
      // iOS Safari detected, load banner data and redirect to webshop and show the banner
      if (me._isSafariOnIOS) {
        // Redirect to the webshop
        me._handleJumpLinkWebshopNavigation(service, locationid);
        me._loadAndSetBannerData(service, locationid);
      } else {
        // Redirect directly to the app for non-iOS Safari users
        me._redirectToApp(service, locationid);
      }
    } catch (error) {
      me._coreLogService.error("AppComponent.ngOnInit", "_handleAppNavigation", error);
      me._handleJumpLinkWebshopNavigation(service, locationid);
    }
  }

  /**  Redirects to the app using the Intent Scheme */
  private _redirectToApp(service: number, locationid: number) {
    const me = this;
    const hasGooglePlayStoreLink = !Utils.IsNullOrEmpty(environment.storeURL.GooglePlayStore);
    if (hasGooglePlayStoreLink) {
      try {
        const target = `${environment.IntentScheme}://${me._getLink(service, locationid)}`;
        me.setWebshopServiceAndLocation(service, locationid);
        // Open the app 
        window.open(target, "_self");
      } catch (error) {
        me._coreLogService.error("AppComponent.tryOpenApp", "window.open, open application", error);
        me._handleJumpLinkWebshopNavigation(service, locationid);
      }
    }
  }

  /** Loads the banner data and sets it in the BannerService*/
  //! MARK On iOS, the banner is displayed, requiring user confirmation before redirecting to the app.
  private _loadAndSetBannerData(service: number, locationid: number) {
    const me = this;
    me._bannerService.setRequiredData(true, me._getLink(service, locationid));
  }

  /** Sets the webshop service mode and location
    * @param service The service mode
    * @param loc The location ID
   */
  private setWebshopServiceAndLocation(service: number, loc: number): void {
    const me = this;
    if (service !== null && service >= 0) {
      me._webShopService.setServiceMode(service).then(() => {
        if (loc !== null && loc >= 0) {
          me._webShopService.setServiceLocationByID(loc);
        }
      });
    }
  }

  /** Generates a link for the webshop with the given service and location*/
  private _getLink(service: number, loc: number): string {
    const me = this;
    // Default navigation on the start screen
    let link = "";
    // Build the final link based on available parameters
    const params = new URLSearchParams();
    params.set("type", "jump");
    if (service !== null && service >= 0) {
      params.set("ser", service.toString());
      if (loc !== null && loc >= 0) {
        params.set("loc", loc.toString());
      }
    }
    // e.g.type = jump & ser=1 & loc=12345
    link = params.toString();
    return link;
  }

  ngAfterViewInit() {
    const me = this;
    me._viewportHelperService.setViewHeight();
    // Readjust slighlty delayed for some devices
    setTimeout(() => {
      me._viewportHelperService.setViewHeight();
    }, 400);
    // Replace the Default OverlayContainer with our CustomOverlayContainer.
    // Mainly used for disabling Angular Animation for Dialogs, so we can use custom css animation
    // to avoid the choppy behaviour on Android Devices.
    // ! This disables all animations on the Overlay. e.g. this includes Selects.
    // ! New Animations have to be authored using css transition and animation.
    (this._overlayContainer as CustomOverlayContainer).setContainer(
      this.dialogContainer.nativeElement
    );
  }
}
